import { useEffect, useState } from "react";
import { loadCaptures } from "../api";
import type { DecisionCapture } from "../lib/types";
import { useBuilderStore } from "../store";

export function CaptureViewer({ taskRunId }: { taskRunId: string }) {
  const accountId = useBuilderStore((state) => state.accountId);
  const [captures, setCaptures] = useState<DecisionCapture[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void loadCaptures(accountId, taskRunId)
      .then(setCaptures)
      .catch(() => setError("Captures are unavailable or you do not have access."));
  }, [accountId, taskRunId]);

  return (
    <main className="tj-container space-y-4 py-4">
      <header>
        <p className="text-xs uppercase tracking-wide text-[var(--tj-muted)]">Decision evidence</p>
        <h1 className="serif-heading text-2xl">Capture viewer</h1>
        <p className="text-sm text-[var(--tj-muted)]">
          Screenshots stay on the PVR3 artifact volume for 60 days. They are never OCR'd into logs or sent to a model.
        </p>
      </header>
      {error ? <p className="text-red-700">{error}</p> : null}
      {captures.length === 0 && !error ? (
        <p className="text-sm text-[var(--tj-muted)]">No decision captures recorded for this run.</p>
      ) : (
        <ol className="space-y-2">
          {captures.map((capture) => (
            <li key={capture.capture_id} className="rounded-xl border border-[var(--tj-border)] bg-[var(--tj-surface)] p-3 text-sm">
              <p className="font-medium">
                {capture.decision_id} · {capture.mode}
              </p>
              <p className="text-[var(--tj-muted)]">
                step {capture.step_id} · {new Date(capture.taken_at).toLocaleString()}
              </p>
              <p className="mt-1 break-all font-mono text-xs">{capture.screenshot_ref}</p>
              <p className="mt-1 text-xs text-[var(--tj-muted)]">
                page {capture.page_fingerprint} · ax {capture.ax_snapshot_hash} · vars {capture.vars_snapshot_hash}
              </p>
            </li>
          ))}
        </ol>
      )}
    </main>
  );
}
